import { supabase } from '../../../lib/supabaseClient';

export async function getDraftAcknowledgments(reservationId) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const { data, error } = await supabase
    .from('asp_draft_acknowledgments')
    .select('*')
    .eq('reservation_id', reservationId)
    .eq('buyer_id', user.id)
    .maybeSingle();

  if (error) throw error;
  return data;
}

export async function saveDraftAcknowledgments(reservationId, acknowledgments) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not authenticated');

  const { data, error } = await supabase
    .from('asp_draft_acknowledgments')
    .upsert({
      reservation_id: reservationId,
      buyer_id: user.id,
      acknowledgments
    }, {
      onConflict: 'reservation_id,buyer_id'
    })
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function deleteDraftAcknowledgments(reservationId) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not authenticated');

  const { error } = await supabase
    .from('asp_draft_acknowledgments')
    .delete()
    .eq('reservation_id', reservationId)
    .eq('buyer_id', user.id);

  if (error) throw error;
}
